import { EventType } from "../event-type";

export class HerdoutType extends EventType {

    public static readonly DEATH = new HerdoutType("herdOutByDeath", "Morte");
    public static readonly DISCARD = new HerdoutType("herdOutByDiscard", "Descarte");
    public static readonly SALE = new HerdoutType("herdOutBySale", "Venda");

    private constructor(
        public readonly name: string,
        public readonly label: string,
        public readonly iconPath: string = EventType.HERDOUT.iconPath,
        public readonly backgroundColor: string = EventType.HERDOUT.backgroundColor
    ) {
        super(name, label, iconPath, backgroundColor);
    }

    public static get(name: string): HerdoutType {
        const type = Object.values(HerdoutType).find(it => it.name === name);
        if (!type) {
            throw new Error(`${name} is not a mapped HerdoutType.`);
        }
        return type;
    }

}
